import { render, staticRenderFns } from "./AttendeeLobby.vue?vue&type=template&id=56e84c53&lang=pug"
import script from "./AttendeeLobby.vue?vue&type=script&lang=ts"
export * from "./AttendeeLobby.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports